import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';

export const WhatsAppButton = () => {
  const [isExpanded, setIsExpanded] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExpanded(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <a
      href="https://api.whatsapp.com/send/?phone=33614154590&text=Bonjour%2C+vous+%C3%AAtes+disponible+%3F&type=phone_number&app_absent=0"
      target="_blank"
      rel="noopener noreferrer"
      className={`
        fixed bottom-6 right-6 bg-primary-600 text-white p-4 rounded-full 
        shadow-lg hover:bg-primary-700 transition-all duration-300 z-50 
        flex items-center gap-2 group
      `}
      aria-label="Nous contacter sur WhatsApp"
    >
      <MessageCircle className="h-6 w-6" />
      <span 
        className={`
          whitespace-nowrap transition-all duration-500 ease-in-out
          ${isExpanded ? 'max-w-[200px] opacity-100' : 'max-w-0 opacity-0 group-hover:max-w-[200px] group-hover:opacity-100'}
        `}
      >
        Nous contacter
      </span>
    </a>
  );
};